import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
      
      <div className="prose max-w-none">
        <p className="text-gray-700 mb-6">Last updated: November 17, 2025</p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Information We Collect</h2>
        <p className="text-gray-700 mb-4">
          We collect information that you provide directly to us, such as when you fill out our contact form. This may include your name, email address, phone number, and any other information you choose to provide.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. How We Use Your Information</h2>
        <p className="text-gray-700 mb-4">
          We use the information we collect to:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
          <li>Respond to your inquiries and provide customer support</li>
          <li>Improve our website and services</li>
          <li>Send you updates and promotional materials (with your consent)</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Cookies and Tracking Technologies</h2>
        <p className="text-gray-700 mb-4">
          We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. Third-Party Services</h2>
        <p className="text-gray-700 mb-4">
          We may employ third-party companies and individuals to facilitate our website, provide services on our behalf, or assist us in analyzing how our website is used. These third parties have access to your Personal Information only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. Google AdSense</h2>
        <p className="text-gray-700 mb-4">
          We use Google AdSense to display advertisements on our website. Google AdSense may use cookies and web beacons to serve ads based on your visit to our site and other sites on the Internet.
        </p>
        <p className="text-gray-700 mb-4">
          You may opt out of personalized advertising by visiting <a href="https://adssettings.google.com/" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:underline">Google Ads Settings</a>.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. Changes to This Privacy Policy</h2>
        <p className="text-gray-700 mb-4">
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. Contact Us</h2>
        <p className="text-gray-700 mb-4">
          If you have any questions about this Privacy Policy, please contact us at:
        </p>
        <p className="text-gray-700">
          Varmin Pharmaceuticals Pvt. Ltd.<br />
          Email: varminpharmaceuticals@gmail.com<br />
          Phone: +91 94521 01977
        </p>
      </div>

      <div className="mt-12">
        <Link to="/" className="text-green-600 hover:underline">
          &larr; Back to Home
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
